import React from 'react';
import style from './DropdownNav.module.scss';
import Link from 'gatsby-link';
import jump from 'jump.js';

const DropdownNav = ({
  isPlaylistOpen,
  isVideoOpen,
  isDropdownNavOpen,
  handleDropdownChange,
  mainNavColor,
  chapters,
  handleDropdownNav,
  isMenuCollapsed,
  isCurrentPage,
  isDesktop,
  isMobile,
  eras,
  handleChapterNav,
  timelinePath,
  registerEraSkip,
}) => {
  const handleDropdownNavToggle = () => {
    handleDropdownChange();
  };

  const filteredEras =
    eras &&
    Array.isArray(eras) &&
    eras.filter((era, index) => !era.add_link_to_about_page);

  return (
    <div
      className={`js-dropdownNav
        ${mainNavColor === 'black' ? style.blackNav : ''}
        ${mainNavColor === 'white' ? style.whiteNav : ''}
        ${style.dropdownNavWrapper}
        ${isCurrentPage ? style.dropdownVisible : style.dropdownHidden}
        ${isDesktop ? style.isDesktop : ''}
        ${isMobile ? style.isMobile : ''}
      `}
      style={{ pointerEvents: isPlaylistOpen || isVideoOpen ? 'none' : 'auto' }}
    >
      <div
        className={`dropdownNavTrigger ${style.dropdownNavTrigger}`}
        onClick={handleDropdownNavToggle}
      >
        {chapters ? 'View All Chapters' : 'View All'}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="9"
          viewBox="0 0 15 9"
          className={`dropdownNavArrow ${
            isDropdownNavOpen ? style.dropdownNavArrowOpen : ''
          } ${style.dropdownNavArrow}`}
        >
          <title>Down Caret</title>
          <polygon points="13.93 .212 14.637 .919 7.201 8.355 0 .684 .729 0 7.224 6.918" />
        </svg>
      </div>
      <ul
        className={`${isDropdownNavOpen ? style.dropdownNavOpen : ''} ${
          style.dropdownNav
        } dropdownMenuContainer`}
        style={{
          pointerEvents: isDropdownNavOpen
            ? isPlaylistOpen || isVideoOpen
              ? 'none'
              : 'auto'
            : 'none',
        }}
      >
        {eras &&
          Array.isArray(eras) &&
          filteredEras.map((era, i) => {
            return (
              !era.add_link_to_about_page && (
                <li className="js-dropdownNavItem" key={`eraLink${i}`}>
                  <a
                    href={`#years${era.starting_year}`}
                    onClick={e => {
                      e.preventDefault();
                      handleDropdownNavToggle();
                      registerEraSkip({
                        index: i,
                        era: era,
                        skipTo: () => {
                          jump(`#years${era.starting_year}`, {
                            offset: -100,
                            duration: 0,
                          });
                        },
                      });
                    }}
                  >
                    {era.starting_year} {era.ending_year && '–'}{' '}
                    {era.ending_year}
                  </a>
                </li>
              )
            );
          })}
        {chapters &&
          chapters.map((chapter, i) => (
            <li
              className="js-dropdownNavItem"
              key={`chapter${chapter.id}`}
              onClick={handleDropdownNavToggle}
            >
              <Link
                to={chapter.path}
                activeClassName="activeDropdownLink"
                onClick={e => {
                  e.preventDefault();
                  if (handleChapterNav) {
                    handleChapterNav(i);
                  }
                }}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: `Chapter ${i + 1}: ${chapter.title}`,
                  }}
                />
              </Link>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default DropdownNav;



// WEBPACK FOOTER //
// ./src/components/global/DropdownNav.js